// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "card-32yIf";
var _4 = "paylate-3w6CE";
var _5 = "cards_header-35DWX";
var _6 = "gateway__arrow-At7Bi";
var _7 = "header__arrow-15RnK";
var _8 = "gateways-2-3Ez";
var _9 = "gateways_hidden-1Hi-L";
var _a = "gateway__selector-cDwsK";
var _b = "cards-2Wpss";
var _c = "details__button-29rg4";
var _d = "summaryGroup_priceParts-R6qWo";
var _e = "summaryGroup_total-1b3bq";
var _f = "details__total-xR_wP";
var _10 = "summaryGroup_order-2QjSi";
export { _1 as "__esModule", _2 as "mobile", _3 as "card", _4 as "paylate", _5 as "cards_header", _6 as "gateway__arrow", _7 as "header__arrow", _8 as "gateways", _9 as "gateways_hidden", _a as "gateway__selector", _b as "cards", _c as "details__button", _d as "summaryGroup_priceParts", _e as "summaryGroup_total", _f as "details__total", _10 as "summaryGroup_order" }
export default { "__esModule": _1, "mobile": _2, "card": _3, "paylate": _4, "cards_header": _5, "gateway__arrow": _6, "header__arrow": _7, "gateways": _8, "gateways_hidden": _9, "gateway__selector": _a, "cards": _b, "details__button": _c, "summaryGroup_priceParts": _d, "summaryGroup_total": _e, "details__total": _f, "summaryGroup_order": _10 }
